import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35420ee5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brush-map__select-color" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "brush-map__title" }, "3. Выберите цвет ёршика", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "brush-map__subtitle brush-map__subtitle_grey" }, [
  /*#__PURE__*/_createTextVNode(" Нажмите на нужный Вам цвет ёршика "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" и окрасьте нужное место. ")
], -1))
const _hoisted_4 = { class: "brush-map__current-color" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Текущий цвет:", -1))


import FirmCuraprox from './FirmColors/FirmCuraprox.vue'
import FirmCurasept from './FirmColors/FirmCurasept.vue'
import FirmTepe from './FirmColors/FirmTepe.vue'
import FirmInterprox from './FirmColors/FirmInterprox.vue'
import FirmPesitro from '@/pages/BrushMapPage/components/BrushMapAside/components/BrushSelectColor/FirmColors/FirmPesitro.vue'
// import FirmReviline from '@/pages/BrushMapPage/components/BrushMapAside/components/BrushSelectColor/FirmColors/FirmReviline.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  currentName: String,
  currentColor: String,
  brushesFirm: Object,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _withDirectives(_createVNode(FirmCuraprox, {
        onChangeColor: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('changeColor', $event)))
      }, null, 512), [
        [_vShow, __props.brushesFirm.nameFirm === 'Curaprox']
      ]),
      _withDirectives(_createVNode(FirmTepe, {
        onChangeColor: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('changeColor', $event)))
      }, null, 512), [
        [_vShow, __props.brushesFirm.nameFirm === 'TePe']
      ]),
      _withDirectives(_createVNode(FirmInterprox, {
        onChangeColor: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('changeColor', $event)))
      }, null, 512), [
        [_vShow, __props.brushesFirm.nameFirm === 'Interprox']
      ]),
      _withDirectives(_createVNode(FirmCurasept, {
        onChangeColor: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('changeColor', $event)))
      }, null, 512), [
        [_vShow, __props.brushesFirm.nameFirm === 'Curasept']
      ]),
      _withDirectives(_createVNode(FirmPesitro, {
        onChangeColor: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('changeColor', $event)))
      }, null, 512), [
        [_vShow, __props.brushesFirm.nameFirm === 'Pesitro']
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", {
        style: _normalizeStyle({ background: __props.currentColor })
      }, null, 4),
      _createElementVNode("p", null, _toDisplayString(__props.currentName), 1)
    ])
  ], 64))
}
}

})